import { Fragment } from 'react';
import { Playground, Props } from 'docz';
import locale from 'date-fns/locale/fr';
import { Datepicker } from 'lib';
import * as React from 'react';
export default {
  Fragment,
  Playground,
  Props,
  locale,
  Datepicker,
  React
};